export const tableActionButtons = (): { tableActionButtonsRowWidth: (maxVisibleButtonsCount: number) => string } => {
  const tableActionButtonsRowWidth = (maxVisibleButtonsCount: number): string => {
    const buttonWidht = 32 // @element-height-m
    const buttonMargin = 2 * 4 // 2 * @spacing-xxxs
    //const buttonWrapper = 2 * 20 // 2 * @spacing-m
    const tablePadding = 2 * 12 // 2 * @spacing-s
    const rowWidth = maxVisibleButtonsCount * (buttonWidht + buttonMargin) + tablePadding /* + buttonWrapper */
    return `${rowWidth < 70 ? 70 : rowWidth}px`
  }

  return {
    tableActionButtonsRowWidth,
  }
}
